import React from "react";
import { twMerge } from "tailwind-merge";
import { MotionConfig, motion } from "framer-motion";
import { FiArrowRight } from "react-icons/fi";

export const SpringCards = ({ name, description, css, height, imageUrl, link }) => {
  return (
    <div 
      className="w-full h-full flex items-stretch" 
      style={{ minHeight: '300px' }}
    >
      <Card 
        title={name}
        subtitle={description}
        imageUrl={imageUrl}
        link={link}
        css={css}
      />
    </div>
  );
};

const Card = ({ title, subtitle, imageUrl, link, css }) => {
  return (
    <MotionConfig
      transition={{
        type: "spring",
        bounce: 0.5,
      }}
    >
      <motion.div
        whileHover="hovered"
        className="group w-full h-full border-2 border-black"
        style={{ background: "transparent" }}
      >
        <motion.div
          initial={{ x: 0, y: 0 }}
          variants={{
            hovered: {
              x: -8,
              y: -8,
            },
          }}
          className="-m-0.5 border-2 border-black h-full"
        >
          <motion.div
            initial={{ x: 0, y: 0 }}
            variants={{
              hovered: {
                x: -8,
                y: -8,
              },
            }}
            className="relative -m-0.5 flex flex-col justify-between h-full overflow-hidden border-2 border-black p-4"
          >
            <div className="flex justify-between items-start">
              <p className="flex items-center text-2xl font-medium uppercase">
                <FiArrowRight className="-ml-8 mr-2 opacity-0 transition-all duration-300 ease-in-out group-hover:ml-0 group-hover:opacity-100" />
              </p>
            </div>

            <div className="flex-grow flex items-center justify-center">
              <img 
                src={imageUrl} 
                alt={title} 
                className="max-w-56 max-h-full object-contain"
              />
            </div>

            <div>
              <a 
                href={link} 
                target="_blank" 
                rel="noopener noreferrer"
                className="absolute bottom-2 left-2 right-2 translate-y-full border-2 border-black bg-white px-4 py-2 text-black opacity-0 transition-all duration-300 ease-in-out group-hover:translate-y-0 group-hover:opacity-100 text-center"
              >
                En savoir plus
              </a>
            </div>

            <motion.svg
              initial={{ rotate: 0 }}
              animate={{ rotate: 360 }}
              transition={{
                duration: 25,
                repeat: Infinity,
                repeatType: "loop",
                ease: "linear",
              }}
              style={{
                top: "0",
                right: "0",
                x: "50%",
                y: "-50%",
                scale: 0.75,
              }}
              width="200"
              height="200"
              className="pointer-events-none absolute z-10 rounded-full"
            >
              <path
                id="circlePath"
                d="M100,100 m-100,0 a100,100 0 1,0 200,0 a100,100 0 1,0 -200,0"
                fill="none"
              />
              <text>
                <textPath
                  href="#circlePath"
                  fill="black"
                  className="fill-black text-2xl font-black uppercase opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100"
                >
                  LEARN MORE • LEARN MORE • LEARN MORE • LEARN MORE •
                </textPath>
              </text>
            </motion.svg>
          </motion.div>
        </motion.div>
      </motion.div>
    </MotionConfig>
  );
};